'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import * as React from 'react';

function ThemeProvider({ children, scriptProps, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  // next-themes injects a blocking inline script to prevent theme flash. React 19 warns when
  // that script is reconciled on the client, even though SSR already executed it.
  const react19ScriptProps = typeof window === 'undefined' ? undefined : ({ type: 'application/json' } as const);

  return (
    <NextThemesProvider {...props} scriptProps={scriptProps ?? react19ScriptProps}>
      {children}
    </NextThemesProvider>
  );
}

export { ThemeProvider };
